import { useState, useMemo, useEffect } from 'react';
import I18n from 'I18n';
import debounce from 'transmute/debounce';
import get from 'hs-lodash/get';
import UISearchInput from 'UIComponents/input/UISearchInput';
import { useQuery } from 'data-fetching-client';
import { getFormattedMessageWithObjectTypeName } from 'automation-ui-i18n/i18nUtils';
import { GET_OBJECT_TYPE_BY_ID } from 'automation-ui-references/object-type-properties/ObjectTypesQueries';
import ObjectType from 'automation-ui-references/object-types/ObjectType';
import DataPassingPanelHeaderInputSkeleton from 'automation-ui-formula-editor/data-passing-panel/DataPanelRevisedUXMode/DataPassingPanelHeaderInputSkeleton';
import { getToObjectType } from 'automation-ui-formula-editor/data-passing-panel/utils/getToObjectType';
import { jsx as _jsx } from "react/jsx-runtime";
export const SEARCH_QUERY_DEBOUNCE_DELAY = 200;
const DataPassingPanelHeaderSearchProperties = ({
  flowObjectTypeId,
  onDataSourceSearch,
  searchFilterString,
  dataSource
}) => {
  const {
    dataSourceDefinition
  } = dataSource || {};
  const objectTypeId = getToObjectType(dataSourceDefinition, flowObjectTypeId);
  const [searchText, setSearchText] = useState(searchFilterString);
  const {
    loading,
    data
  } = useQuery(GET_OBJECT_TYPE_BY_ID, {
    skip: !objectTypeId,
    variables: {
      objectTypeId
    }
  });
  useEffect(() => {
    if (searchFilterString === searchText) {
      return;
    }
    setSearchText(searchFilterString);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchFilterString]);
  const setSearchQueryDebounced = useMemo(() => {
    return debounce(200, onDataSourceSearch);
  }, [onDataSourceSearch]);
  if (loading) {
    return /*#__PURE__*/_jsx(DataPassingPanelHeaderInputSkeleton, {
      "data-test-id": "data-panel-search-properties-input-skeleton"
    });
  }
  const objectTypeDefinition = get(data, 'objectTypeById', new ObjectType());
  const placeholder = objectTypeId ? getFormattedMessageWithObjectTypeName({
    baseLangKey: 'automation-ui-formula-editor.data-passing-panel.panel-header.search-box.place-holder_cob',
    objectTypeId,
    objectTypeDefinition: objectTypeDefinition
  }) : I18n.text('automation-ui-formula-editor.data-passing-panel.panel-header.search-box.place-holder');
  return /*#__PURE__*/_jsx(UISearchInput, {
    "aria-label": I18n.text('automation-ui-formula-editor.data-passing-panel.panel-header.search-box.label'),
    name: "searchAvailableData",
    "data-test-id": "search-data-panel-properties",
    placeholder: placeholder,
    onChange: event => {
      setSearchText(event.currentTarget.value);
      setSearchQueryDebounced(event.currentTarget.value);
    },
    value: searchText
  });
};
export default DataPassingPanelHeaderSearchProperties;